import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

import * as FormGroups from './formGroups'

const EditarZonaModal = ({ handleClose, show, onSuccess, modalData, tipoTabla }) => {
  const __zariContext = React.useContext(ZariContext)

  const nombreTabla = React.useMemo(() => {
    return TiposTablaComunConstant.__dictionary[tipoTabla].nombre
  }, [tipoTabla])

  const submitHandler = async data => {
    if (modalData._id) {
      await TablasComunesService.actualizarxId(modalData._id, data)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha actualizado.')
          onSuccess()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      await TablasComunesService.nuevo(data)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha creado.')
          onSuccess()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  const formInitialValues = React.useMemo(
    () => ({
      _idDepartamento: modalData._idDepartamento || '',
      _idProvincia: modalData._idProvincia || '',
      codigo: modalData.codigo || '',
      estado: modalData.estado || '',
      nombre: modalData.nombre || '',
      porcentaje: modalData.porcentaje || '',
      se: modalData.se || '',
      tipo: tipoTabla,
      unidadSunat: modalData.unidadSunat || ''
    }),
    [modalData, tipoTabla]
  )

  const modalBodyComponents = React.useCallback(
    ({ errors, isSubmitting, touched, values }) => {
      switch (tipoTabla) {
        case TiposTablaComunConstant.PAIS:
          return (
            <>
              <FormGroups.CodigoFormGroup iError={errors.codigo} iTouched={touched.codigo} fIsSubmitting={isSubmitting} />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaComunConstant.DEPARTAMENTO:
          return (
            <>
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaComunConstant.PROVINCIA:
          return (
            <>
              <FormGroups.IdDepartamentoFormGroup iError={errors._idDepartamento} iTouched={touched._idDepartamento} fIsSubmitting={isSubmitting} />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaComunConstant.DISTRITO:
          return (
            <>
              <FormGroups.IdDepartamentoFormGroup iError={errors._idDepartamento} iTouched={touched._idDepartamento} fIsSubmitting={isSubmitting} />
              <FormGroups.IdProvinciaFormGroup
                iError={errors._idProvincia}
                iTouched={touched._idProvincia}
                fIsSubmitting={isSubmitting}
                vIdDepartamento={values._idDepartamento}
              />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaComunConstant.DETRACCION:
          return (
            <>
              <FormGroups.CodigoFormGroup iError={errors.codigo} iTouched={touched.codigo} fIsSubmitting={isSubmitting} />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
              <FormGroups.PorcentajeFormGroup iError={errors.porcentaje} iTouched={touched.porcentaje} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaComunConstant.TIPOOPERACIONSUNAT:
          return (
            <>
              <FormGroups.CodigoFormGroup iError={errors.codigo} iTouched={touched.codigo} fIsSubmitting={isSubmitting} />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
              <FormGroups.SeInventarioTipoFormGroup iError={errors.se} iTouched={touched.se} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaComunConstant.UNIDADESMEDIDA:
          return (
            <>
              <FormGroups.CodigoFormGroup iError={errors.codigo} iTouched={touched.codigo} fIsSubmitting={isSubmitting} />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
              <FormGroups.UnidadSunatFormGroup iError={errors.unidadSunat} iTouched={touched.unidadSunat} fIsSubmitting={isSubmitting} />
            </>
          )
        default:
          return (
            <>
              <FormGroups.CodigoFormGroup iError={errors.codigo} iTouched={touched.codigo} fIsSubmitting={isSubmitting} />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </>
          )
      }
    },
    [tipoTabla]
  )

  return (
    <Modal show={show} onHide={handleClose} size='md'>
      <Modal.Header>
        <Modal.Title>{`${modalData._id ? 'EDITAR' : 'CREAR'} - ${nombreTabla}`}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, values }) => (
          <Form>
            <Modal.Body>
              {modalBodyComponents({ errors, isSubmitting, touched, values })}
              <FormGroups.EstadoFormGroup iError={errors.estado} iTouched={touched.estado} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>{modalData._id ? 'Actualizar' : 'Crear'}</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarZonaModal
